<div class="org-split-screen">
  <div class="org-split-screen__section --left">
    <div class="org-split-screen__section__banner">
      <img src="assets/imgs/section-banner.jpeg" alt="banner" />
    </div>
  </div>
  <div class="org-split-screen__section --right">
    <div class="org-split-screen__section__content">
      <img
        *ngIf="showHeroImage"
        class="org-split-screen__section__hero"
        src="assets/icons/proquifa-logo-full-color.svg"
        alt=""
      />
      <ng-content select="[right-side]"></ng-content>
    </div>
  </div>
</div>
